export default "__VITE_ASSET__DGD5Mu7b__"